import {handleAPI, API_VERSION_ONE_ADMIN} from '../../utils/apiUtils';

export function importLoad(data){
  const url = `/${API_VERSION_ONE_ADMIN}/settings/import`
  const method = "POST"
  return {
    type: 'IMPORT_LOAD',
    payload: handleAPI(url, {}, method, data)
  };
}